/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_CustomersInputs */

const en_admin_customers = /** @type {(inputs: Admin_CustomersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Customers`)
};

const nl_admin_customers = /** @type {(inputs: Admin_CustomersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klanten`)
};

/**
* | output |
* | --- |
* | "Customers" |
*
* @param {Admin_CustomersInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const admin_customers = /** @type {((inputs?: Admin_CustomersInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_CustomersInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_admin_customers(inputs)
	return en_admin_customers(inputs)
});